<div class="row d-flex align-items-center">
  <div>
    <div class="my-2" *ngFor="let search of searchFields">
      <div class="d-flex align-items-center" style="width: 400px;">
        <input class="form-control" type="text" (keydown.enter)="searchClients()" [(ngModel)]="search.fieldValue"
          [placeholder]="'global.search' | translate">
        <select class="form-control mx-2" name="" id="" [(ngModel)]="search.fieldKey">
          <option value="" translate>customer.selectOption</option>
          <option value='name' translate>global.name</option>
          <option value='email'>Email</option>
          <option value='country' translate>customer.country</option>
          <option value='city' translate>customer.city</option>
          <option value='address' translate>customer.address</option>
          <option value='postCode' translate>customer.postCode</option>
        </select>
        <span *ngIf="search.button === 'add' && searchFields.length < 3" (click)="addField()"><i
            class="fa fa-plus"></i></span>
        <span *ngIf="search.button === 'remove'" (click)="removeField(search)"><i style="cursor: pointer;"
            class="fa fa-minus"></i></span>
      </div>
    </div>
  </div>

  <div class="ml-5 mr-2" *ngIf="customerAllClients">
    <select class="form-control mx-2" name="" id="" [ngModel]="creditsOrder || ''" (change)="creditsSort($event.target.value)">
      <option value="" translate>customer.credits</option>
      <option value='asc' translate>customer.creditAcc</option>
      <option value='desc' translate>customer.creditDesc</option>
    </select>
  </div>
  <div  *ngIf="customerAllClients">
    <select class="form-control mx-2" name="" id="" [ngModel]="creditsPaymentType || ''"(change)="creditsType($event.target.value)">
      <option value="" translate>customer.paymentType</option>
      <option value='prepaid' translate>customer.prepaid</option>
      <option value='postpaid' translate>customer.postpaid</option>
    </select>
  </div>
</div>
<button *ngIf="customerAllClients" style="width: 150px;" class="custom-button" (click)="searchClientsbySubcustomer()" translate>customer.search</button>
<button *ngIf="!customerAllClients" style="width: 150px;" class="custom-button" (click)="searchClients()" translate>customer.search</button>